import AddMissingBanner from "../../assets/add-missing-tracks.png";
import HomeBanner from "../../assets/home-banner.png";
import playlistLibrary from "../../assets/undraw_playlist_libraby.svg";
import match from "../../assets/match.svg";
import secure from "../../assets/secure.svg";
import bulk from "../../assets/undraw_bulk.svg";
import history from "../../assets/undraw_history.svg";
import TransferBanner from "../../assets/transfer-playlist.png";
import VerifyTransferBanner from "../../assets/verify-transfer.png";

import { Link } from "react-router-dom";
import config from "../../config";

import { OptimizeSEO } from "../../components/OptimizeSEO";
import { SUPPORTED_APPS } from "../../constants/HomePageConstants";
import { seoContent } from "../../constants/SEOConstant";
import "../homePage/index.css";

function SupportedPlatforms() {
  return (
    <div className="bg-white dark:bg-zinc-800 py-24 sm:py-8">
      <div className="mx-auto max-w-7xl px-4">
        <div className="mx-auto max-w-4xl">
          <p className="mt-2 text-2xl sm:text-3xl md:text-5xl text-center font-extrabold leading-tight tracking-tight text-balance text-gray-900 dark:text-white">
            Transfer Between All Major Music Platforms
          </p>
        </div>
        <p className="mx-auto mt-6 max-w-2xl text-center font-light text-base sm:text-lg md:text-2xl text-gray-500 dark:text-gray-400">
          Seamlessly move your music between Spotify, Apple Music, YouTube Music, YouTube, and Tidal. No platform limitations.
        </p>

        <div className="isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 lg:mx-0 lg:max-w-none sm:grid-cols-2 lg:grid-cols-3">
          {SUPPORTED_APPS.map(({ id, name, icon, link }) => (
            <Link to={link} key={id} className="card-link">
              <div key={id} className="card custom-card">
                <h3 className="card-title text-gray-900 dark:text-white">{name}</h3>
                <div className="card-icon">
                  <img src={icon} className="responsive-icon" alt={`transfer ${name} playlists`} />
                </div>
              </div>
            </Link>
          ))}
        </div>

        
      </div>
    </div>
  );
}

function MissingTracks() {
  const features = [
    {
      name: "Open transfer history: ",
      description: "In the transfer history page, select add missing tracks.",
    },
    {
      name: "Select missing tracks: ",
      description:
        "Select the songs missed from the dropdown, from the add missing tracks view.",
    },
    {
      name: "Search and add: ",
      description: "Change the search keywords, search and add missing tracks.",
    },
  ];

  return (
    <>
      <div className="max-w-screen-xl px-4 py-8 mx-auto space-y-12 lg:space-y-20 lg:py-24 lg:px-6">
        {/* Row */}
        <div className="items-center gap-8 lg:grid lg:grid-cols-2 xl:gap-16">
          <div className="text-gray-500 sm:text-lg dark:text-gray-400">
            <div className="lg:row-start-2 lg:max-w-md">
              <h2 className="text-3xl font-semibold tracking-tight text-balance text-gray-900 dark:text-white sm:text-4xl">
                Add missing track
              </h2>
              <p className="mt-6 text-lg/8 text-gray-500 sm:text-xl dark:text-gray-400">
                Sometimes metadata do not match across services, and some tracks
                missing be missing. Use our Add missing track feature to quickly
                add them.
              </p>
            </div>

            <div className="pt-4 max-w-xl lg:row-start-3 lg:mt-10 lg:max-w-md lg:border-t lg:border-white/10 lg:pt-10">
              <dl className="max-w-xl space-y-8 text-base/7 text-gray-300 lg:max-w-none">
                {features.map((feature) => (
                  <div key={feature.name} className="">
                    <dt className="inline-block font-semibold text-gray-900 dark:text-white">
                      <span>{feature.name}</span>
                    </dt>{" "}
                    <dd className="inline text-gray-500 dark:text-gray-400">
                      {feature.description}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
          <img
            className="pt-4 w-full mb-4 rounded-lg lg:mb-0 lg:flex"
            src={AddMissingBanner}
            alt="Transfer Playlists, albums and favourite songs"
          />
        </div>
      </div>
    </>
  );
}

function VerifyTransfer() {
  const features = [
    {
      name: "Select Verify and Transfer: ",
      description: "Click Verify and Transfer during the transfer.",
    },
    {
      name: "Verify matches: ",
      description:
        'Once the matches are found, select "Verify and Transfer" from the transfer history.',
    },
    {
      name: "Edit your matches: ",
      description:
        "Verify your matches and add missing ones. You can ignore if you can't find a matching track.",
    },
  ];

  return (
    <>
      <div className="max-w-screen-xl px-4 py-8 mx-auto space-y-12 lg:space-y-20 lg:py-24 lg:px-6">
        {/* Row */}
        <div className="items-center gap-8 lg:grid lg:grid-cols-2 xl:gap-16">
          <div className="text-gray-500 sm:text-lg dark:text-gray-400">
            <div className="lg:row-start-2 lg:max-w-md">
              <div className="flex items-center gap-3 mb-2">
                <h2 className="text-3xl font-semibold tracking-tight text-balance text-gray-900 dark:text-white sm:text-4xl">
                  Verify and Transfer
                </h2>
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-white dark:bg-purple-900 dark:text-white">
                  Coming Soon
                </span>
              </div>
              <p className="mt-6 text-lg/8 text-gray-500 sm:text-xl dark:text-gray-400">
                Use our verify and transfer feature to fix the matches even
                before the transfer. This feature will allow you to review and approve matches before completing your transfer.
              </p>
            </div>

            <div className="pt-4 max-w-xl lg:row-start-3 lg:mt-10 lg:max-w-md lg:border-t lg:border-white/10 lg:pt-10">
              <dl className="max-w-xl space-y-8 text-base/7 text-gray-300 lg:max-w-none">
                {features.map((feature) => (
                  <div key={feature.name} className="">
                    <dt className="inline-block font-semibold text-gray-900 dark:text-white">
                      <span>{feature.name}</span>
                    </dt>{" "}
                    <dd className="inline text-gray-500 dark:text-gray-400">
                      {feature.description}
                    </dd>
                  </div>
                ))}
              </dl>
              
              {/* Coming Soon Notice */}
              <div className="mt-8 p-4 bg-purple-100 dark:bg-purple-900 rounded-lg border border-purple-200 dark:border-purple-800">
                <h4 className="font-semibold text-purple-900 dark:text-white mb-2">
                  🚀 Coming Soon
                </h4>
                <p className="text-purple-800 dark:text-white text-sm">
                  We're working hard to bring you the Verify and Transfer feature. This will give you complete control over your transfer matches before they're applied.
                </p>
              </div>
            </div>
          </div>
          <img
            className="pt-4 w-full mb-4 rounded-lg lg:mb-0 lg:flex opacity-60"
            src={VerifyTransferBanner}
            alt="Transfer Playlists, albums and favourite songs"
          />
        </div>
      </div>
    </>
  );
}

function TransferFeature() {
  const features = [
    {
      name: "Connect your music accounts: ",
      description:
        "Click Add account to connect your source and destination accounts.",
    },
    {
      name: "Select the playlists/albums: ",
      description:
        "Select the source and choose the albums, playlists and saved tracks you want to transfer.",
    },
    {
      name: "Select target account: ",
      description: "Click transfer and choose the target account.",
    },
  ];

  return (
    <>
      <div className="max-w-screen-xl px-4 py-8 mx-auto space-y-12 lg:space-y-20 lg:py-24 lg:px-6">
        {/* Row */}
        <div className="items-center gap-8 lg:grid lg:grid-cols-2 xl:gap-16">
          <div className="text-gray-500 sm:text-lg dark:text-gray-400">
            <div className="lg:row-start-2 lg:max-w-md">
              <h2 className="text-3xl font-semibold tracking-tight text-balance text-gray-900 dark:text-white sm:text-4xl">
                Transfer your songs in 3 steps
              </h2>
              <p className="mt-6 text-lg/8 text-gray-500 sm:text-xl dark:text-gray-400">
                Our streamlined process makes transferring your music library effortless. 
                Connect, select, and transfer — that's it.
              </p>
            </div>

            <div className="pt-4 max-w-xl lg:row-start-3 lg:mt-10 lg:max-w-md lg:border-t lg:border-white/10 lg:pt-10">
              <dl className="max-w-xl space-y-8 text-base/7 text-gray-300 lg:max-w-none">
                {features.map((feature) => (
                  <div key={feature.name} className="">
                    <dt className="inline-block font-semibold text-gray-900 dark:text-white">
                      <span>{feature.name}</span>
                    </dt>{" "}
                    <dd className="inline text-gray-500 dark:text-gray-400">
                      {feature.description}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
          <img
            className="pt-4 w-full mb-4 rounded-lg lg:mb-0 lg:flex"
            src={TransferBanner}
            alt="Transfer Playlists, albums and favourite songs"
          />
        </div>
      </div>
    </>
  );
}

function BenefitsSection() {
  const benefits = [
    {
      title: "Complete Library Transfer",
      description: "Transfer playlists, albums, and individual tracks.",
      icon: playlistLibrary,
      altText: "Complete Library Transfer"
    },
    {
      title: "Smart Matching",
      description: "Advanced algorithms ensure accurate song matching across platforms.",
      icon: match,
      altText: "Smart Matching"
    },
    {
      title: "Bulk Operations",
      description: "Transfer multiple playlists and albums simultaneously to save time.",
      icon: bulk,
      altText: "Bulk Operations"
    },
    {
      title: "Transfer History",
      description: "Keep track of all your transfers with detailed logs and status updates.",
      icon: history,
      altText: "Transfer History"
    }
  ];

  return (
    <section className="bg-gray-50 dark:bg-zinc-900">
      <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-24 lg:px-6">
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            Why Choose Music Porter for Transfers?
          </h2>
          <p className="mb-5 font-light text-gray-500 sm:text-xl dark:text-gray-400">
            Experience the most reliable and efficient way to transfer your music between platforms.
          </p>
        </div>
        <div className="space-y-8 md:grid md:grid-cols-2 lg:grid-cols-4 md:gap-12 md:space-y-0">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center">
              <img src={benefit.icon} alt={benefit.altText} className="w-24 h-24 rounded-lg mx-auto mb-4" />
              <h3 className="mb-2 text-xl font-bold text-gray-900 dark:text-white">
                {benefit.title}
              </h3>
              <p className="text-gray-500 dark:text-gray-400">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function Transfer() {
  return (
    <>
      <OptimizeSEO {...seoContent.transfer} />

      {/* Hero Section */}
      <section className="bg-gray-50 dark:bg-zinc-950 py-8 sm:py-8">
        <div className="grid max-w-screen-xl px-4 pt-20 pb-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12 lg:pt-28">
          <div className="mr-auto place-self-center lg:col-span-7 text-center sm:text-left">
            <h1 className="max-w-2xl mb-4 text-3xl text-gray-900 font-extrabold leading-none tracking-tight md:text-5xl xl:text-6xl dark:text-white">
              Transfer Playlists, Albums a Songs
            </h1>
            <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
              Move your entire music library between Spotify, Apple Music, YouTube Music, and YouTube. 
              Keep every track, playlist, and album intact with our advanced transfer technology.
            </p>
            <div className="space-y-4 sm:flex sm:space-y-0 sm:space-x-4">
              <Link
                to="/login"
                className="inline-flex items-center justify-center w-full px-5 py-3 text-sm font-medium text-center text-white bg-purple-700 border border-transparent rounded-lg sm:w-auto hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-800"
              >
                Start Transferring Free
              </Link>
            </div>
          </div>
          <div className="lg:mt-0 lg:col-span-5 lg:flex py-4">
            <img src={HomeBanner} alt="Transfer playlists" style={{ borderRadius: '2%' }} />
          </div>
        </div>
      </section>

      {/* Supported Platforms */}
      <SupportedPlatforms />

      {/* Benefits Section */}
      <BenefitsSection />

      {/* Transfer Feature */}
      <section className="bg-white dark:bg-zinc-950">
        <TransferFeature></TransferFeature>
      </section>

      {/* Missing Tracks */}
      <section className="bg-gray-50 dark:bg-zinc-800">
        <MissingTracks></MissingTracks>
      </section>

      {/* Verify Transfer */}
      <section className="bg-white dark:bg-zinc-950">
        <VerifyTransfer></VerifyTransfer>
      </section>

      {/* CTA Section */}
      <section className="bg-gray-50 dark:bg-zinc-800">
        <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-16 lg:px-6">
          <div className="max-w-screen-sm mx-auto text-center">
            <h2 className="mb-4 text-3xl font-extrabold leading-tight tracking-tight text-gray-900 dark:text-white">
              Ready to transfer your music?
            </h2>
            <p className="mb-6 font-light text-gray-500 dark:text-gray-400 md:text-lg">
              Join thousands of users who have successfully transferred their music libraries. 
              Start your first transfer for free today.
            </p>
            <div className="space-y-4 sm:flex sm:space-y-0 sm:space-x-4 justify-center">
              <a
                href={config.signupPath}
                className="inline-flex items-center justify-center w-full px-5 py-3 text-sm font-medium text-center text-white bg-purple-700 border border-transparent rounded-lg sm:w-auto hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-800"
              >
                Sign up for free
              </a>
              <a
                href="/sync-playlists"
                className="text-purple-700 bg-white border border-purple-700 hover:bg-purple-50 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-8 py-3 dark:text-purple-400 dark:border-purple-400 dark:hover:bg-purple-900/20 focus:outline-none dark:focus:ring-purple-800 transition-colors duration-200"
              >
                Learn About Sync
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
